import type { ScreenModule } from "../../../app/screen-module";
import { PublicationsPage } from "../pages";

export default {
	id: "system-admin.catalog",
	path: "/system/catalog",
	area: "system-admin",
	navGroup: "カタログ",
	label: "公開Agent / UCS",
	roles: ["platform_admin", "platform_viewer"],
	backing: "MOCK_ONLY",
	enabled: true,
	component: PublicationsPage,
} satisfies ScreenModule;
